import map from "./canada_map.json";

export const MapCA = map;
